<template>
  <div class="wrapW">
    <div class="titleD">
      <div class="titleDT">{{slaveTitleX}}</div>
      <div>
        <h4 class="titlex">{{slaveTitle}}</h4>
        <h2 class="title">{{title}}</h2>
      </div>
    </div>
    <div class="xian"></div>
    <div class="Tdescribe">{{desc}}</div>
    <ul>
      <li v-for="(item,index) in list" :key="index">
        <div class="img"><img :src="item.img"></div>
        <div class="name">{{item.name}}</div>
        <div class="line"></div>
        <div class="details" v-html="item.desc"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'selectionArea',
  data () {
    return {
      list: [],
      title: '',
      slaveTitle: '',
      slaveTitleX: '',
      desc: ''
    }
  },
  mounted () {
    this.getPlate()
  },
  methods: {
    getPlate () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getPlate', {
      }).then(
        function (res) {
          res = res.data.data
          that.title = res.introduce.title
          that.slaveTitle = res.introduce.slaveTitle.substr(1)
          that.slaveTitleX = res.introduce.slaveTitle.substr(0,1)
          that.list = res.list
          that.desc = res.introduce.desc
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.xian
  margin-bottom .22rem
ul
  width 100%
  display flex
  justify-content space-between
  margin-top 0
  position relative
  z-index 9
  margin-top .3rem
  margin-bottom .5rem
  li
    width 24.5%
    text-align center
    border-radius .1rem
    .img
      width .48rem
      margin .43rem auto
      img
        width 100%
    .name
      font-size .22rem
      color #333333
    .line
      width .36rem
      height 2px
      background #D22016
      margin .19rem auto
    .details
      line-height .22rem
      color #666666
      font-size .16rem
      margin 0 auto
  li:hover
    .name
      color var(--indexColor)
</style>



// WEBPACK FOOTER //
// src/pages/index/components/selectionArea.vue